<template>
  <eg-dropdown no-caret variant="none" right toggle-class="p-0 border-0 ml-3">
    <template #button-content>
      <eg-button
        type="primary"
        size="medium"
        icon="plus-add-more-maximize"
        data-testid="rubric-library-create-new-rubric-button"
      >
        {{ $t("rubrics.createNewRubric") }}
      </eg-button>
    </template>

    <eg-b-dropdown-item
      v-for="option in rubricCreationOptions"
      :key="option.creationType"
      class="paragraph-s"
      @click="openModal(option.creationType)"
    >
      <eg-icon :icon="option.icon" size="small" />
      <div class="d-flex flex-column dropdown-item-details">
        <div class="dropdown-item-title">
          {{ $t(option.translationKey + ".title") }}
        </div>
        <div class="dropdown-item-description text-muted">
          {{ $t(option.translationKey + ".details") }}
        </div>
      </div>
    </eg-b-dropdown-item>
  </eg-dropdown>
</template>

<script>
import { RUBRIC_CREATION_OPTIONS } from "@/constants";
import NewRubricView from "@/views/new_rubric_view";

export default {
  name: "CreateRubricDropdown",
  data() {
    return {
      rubricCreationOptions: RUBRIC_CREATION_OPTIONS,
    };
  },
  methods: {
    openModal(tab) {
      const option = RUBRIC_CREATION_OPTIONS.find(
        (opt) => opt.creationType === tab
      );
      const title = option
        ? this.$t(option.translationKey + ".title")
        : this.$t("rubrics.createRubric");

      this.$openForm("new-rubric-form", {
        forceComponent: NewRubricView,
        isModal: true,
        modalProps: {
          hideFooter: true,
          hideHeader: true,
          size: "large",
          title,
          showBackdrop: true,
          modalClass: "eg-rubric-modal",
        },
        props: {
          isRedirectAfterCreated: false,
          initialTab: tab,
        },
        on: {
          close: () => {
            this.$egModal.hide("modal-new-rubric-form");
          },
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.dropdown-item-title {
  font-weight: var(--typography-font-weight-fw-600);
}
::v-deep {
  .btn.filter-dropdown {
    padding: 0;
    border: none;
  }
  .dropdown-menu {
    border-radius: var(--radius-rd-200);
    text-rendering: geometricPrecision;
    .items-wrapper li {
      border-bottom: 1px solid var(--color-stroke-neutral-default);
    }
  }
  .dropdown-item-details {
    gap: 4px;
  }
  .dropdown-item-description {
    white-space: normal;
    min-width: 348px;
  }
  .dropdown-item {
    gap: 12px;
  }
}
</style>
